// extracted by mini-css-extract-plugin
module.exports = {"weeksPhotos":"WeeksPhotos_weeksPhotos__1i8UM"};